export default "__VITE_ASSET__a65f3c8c__"